import { defineStore } from 'pinia';
import {accountAPI} from "@/api";

export const useAuthStore = defineStore('auth', {
    state: () => ({
        accessToken: localStorage.getItem('accessToken'),
        refreshToken: localStorage.getItem('refreshToken'),
        user: null,
        grade:"",
    }),
    actions: {
        async setupUser(){
            if (this.user == null || this.grade == null){
                let response = await accountAPI.GetUser()
                if(response.success == true){
                    this.user = response.data
                    this.grade = response.data.grade;
                    console.log(this.user.name);
                }
            }
            return this.user
        },

        async login(account, password, isSave) {
            const responseModel = await accountAPI.Login({
                "account": account,
                "password": password
            })
            if(responseModel.success == true) {
                this.user = responseModel.data
                this.accessToken = responseModel.data.accessToken;
                this.refreshToken = responseModel.data.refreshToken;
                this.grade = responseModel.data.grade;
                if (isSave == true) localStorage.setItem('saveId', account);
                localStorage.setItem('accessToken', this.accessToken);
                localStorage.setItem('refreshToken', this.refreshToken);
            }else{
                localStorage.removeItem('saveId');
            }
            return responseModel;
        },


        logout() {
            this.accessToken = null;
            this.refreshToken = null;
            this.user = null;
            localStorage.removeItem('accessToken');
            localStorage.removeItem('refreshToken');
        },
    }
})